export enum AccountType {
  retail = 'RETAIL',
  sme = 'SME',
}

export enum SignInResponseStatus {
  mfaRequired = 'MFA_REQUIRED',
  passwordUpdateRequired = 'PASSWORD_UPDATE_REQUIRED',
  accountLocked = 'ACCOUNT_LOCKED',
  // Returned on a 429 while a progressive per-email backoff or per-IP rate limit is in effect.
  tooManyAttempts = 'TOO_MANY_ATTEMPTS',
}

export enum MfaStatus {
  notEnrolled = 'NOT_SET',
}

export const STATUS_MISSING_PARAMETERS = 'MISSING_PARAMETERS';
